import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  infoGrid: {
    marginBottom: 8,
  },
  icon: {
    marginRight: '.5rem',
  },
  label: {
    opacity: 1,
    color: theme.palette.black.main,
    fontSize: 14,
    paddingLeft: 5,
  },
}));

export default useStyles;
